export default {
  common: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    remove: 'Remove',
    next: 'Next',
    back: 'Back',
    loading: 'Loading...',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
  },

  categories: {
    marketing: 'Marketing',
    marketingDesc: 'Promotions, offers and news',
    utility: 'Utility',
    utilityDesc: 'Order notifications, confirmations',
  },

  buttonTypes: {
    quickReply: 'Quick Reply',
    quickReplyDesc: 'Quick reply button (max 10)',
    url: 'Visit Website',
    urlDesc: 'Link to external website (max 1)',
  },

  headerTypes: {
    none: 'None',
    text: 'Text',
    image: 'Image',
    document: 'Document',
    video: 'Video',
  },

  statuses: {
    all: 'All statuses',
    pending: 'Under Review',
    approved: 'Approved',
    rejected: 'Rejected',
  },

  wizard: {
    title: 'Create WhatsApp Template',
    editTitle: 'Edit WhatsApp Template',
    subtitle: 'Configure your message template following Meta\'s guidelines',
    editSubtitle: 'Update the template content and submit for re-approval',
    backToList: 'Back to List',
    submitting: 'Submitting...',
    finish: 'Finish',
    previewTitle: 'Message Preview',
    noChannelError: 'No channel selected. Select a WhatsApp channel.',
    submitError: 'Error creating template',
    submitErrorGeneric: 'An error occurred while saving. Check the fields and try again.',
    connectionError: 'Connection error. Please try again.',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
    steps: {
      info: 'Information',
      type: 'Type',
      content: 'Content',
    },
    stepOf: 'Step {current} of {total}',
    success: {
      title: 'Template Created Successfully!',
      editTitle: 'Template Updated Successfully!',
      message: 'Your template has been submitted for Meta approval. You will be notified when it is approved.',
      editMessage: 'Your template has been updated and submitted for re-approval.',
      viewTemplates: 'View Templates',
      createAnother: 'Create Another',
    },
  },

  preview: {
    placeholder: 'Your message will appear here...',
    contact: 'Customer',
    documentPlaceholder: 'Document.pdf',
    button: 'Button',
    realtimeLabel: 'Real-time preview',
    seeAllOptions: 'See all options',
  },

  step1: {
    title: 'Template Information',
    subtitle: 'Configure the basic information for your message template.',
    guidelinesTitle: 'Meta Guidelines',
    guidelineNameRule: 'Name must contain only lowercase letters (a-z), numbers (0-9) and underline (_)',
    guidelineSpacesRule: 'Spaces are automatically converted to underline (_)',
    guidelineAccentsRule: 'Accents and special characters are automatically removed',
    guidelineLimitRule: 'Maximum limit of {max} characters',
    guidelineApprovalRule: 'All templates require Meta approval',
    nameLabel: 'Template Name *',
    namePlaceholder: 'example_template_name',
    nameEditDisabled: 'Name cannot be changed after creation',
    nameHint: 'Only lowercase letters, numbers and underline (_). Spaces become _',
    nameDuplicateHint: 'A template with this name already exists for the selected language. Choose a different name or change the language.',
    categoryLabel: 'Category *',
    categoryEditDisabled: 'Category cannot be changed after creation',
    languageLabel: 'Language *',
    languageEditDisabled: 'Language cannot be changed after creation',
    channelLabel: 'Associated WhatsApp Channel *',
    channelPlaceholder: 'Select a channel',
    channelLoading: 'Loading channels...',
  },

  step2: {
    title: 'Template Type',
    subtitle: 'Choose the message type that best fits your use case.',
    simpleTitle: 'Simple Message',
    simpleDescription: 'Text only, ideal for quick notifications',
    simpleFeatures: [
      'Body text only',
      'No media or buttons',
      'Ideal for alerts',
    ],
    richTitle: 'Rich Message',
    richDescription: 'Includes header, footer and interactive buttons',
    richFeatures: [
      'Header with text or media',
      'Interactive buttons',
      'Optional footer',
      'Higher engagement',
    ],
  },

  step3: {
    title: 'Template Content',
    subtitlePrefix: 'Configure your message content',
    subtitleRich: 'with header, body, footer and buttons.',
    subtitleSimple: 'as plain text.',
    headerTitle: 'Header',
    headerTextLabel: 'Header Text',
    addVariable: '+ Add Variable',
    headerPlaceholder: 'Message title',
    headerHint: 'Can contain variables',
    imageLabel: 'Image',
    documentLabel: 'Document',
    videoLabel: 'Video',
    fileSelected: 'File selected',
    dropzoneText: 'Click to select or drag the file',
    bodyTitle: 'Message Body *',
    bodyPlaceholder: 'Type the message content here... Use double braces to add dynamic variables (autocomplete).',
    addButton: '+ Add Button',
    variablesLabel: 'Variables:',
    withVariables: '(with variables)',
    withoutVariables: '(without variables)',
    proportionTitle: 'Variable to character ratio:',
    proportionSingle: '{count} variable requires minimum of {min} characters',
    proportionMulti: '{count} variables require minimum of {min} characters',
    proportionPerVar: '({per} per variable)',
    proportionCurrent: 'Current: {count} characters',
    proportionRemaining: '- {remaining} remaining',
    bodyRulesTitle: 'Body Rules',
    bodyRule1: 'Cannot start or end with a variable',
    bodyRule2: 'Cannot have consecutive variables (e.g.:',
    bodyRule3: 'Single line breaks allowed, but not two or more consecutive',
    bodyRule4: 'Limit of {withVars} characters with variables, {withoutVars} without variables',
    bodyRule5: 'Variable ratio: 1 variable = 25 chars minimum, 2+ variables = 20 chars per variable',
    variableValuesTitle: 'Variable Example Values',
    variableValuesDescription: 'Fill in example values for each variable (required for approval).',
    variableValuePlaceholder: 'Example value for variable {index}',
    variableValuesHint: 'Example values have no character limit. No line breaks.',
    footerTitle: 'Footer',
    footerPlaceholder: 'Footer text (optional)',
    footerHint: 'Footer cannot contain variables',
    buttonsTitle: 'Buttons',
    buttonsEmpty: 'No buttons added',
    buttonsEmptyDetails: 'Maximum of 10 buttons total | Quick Reply: up to {maxQuickReply} | URL: up to {maxUrl}',
    buttonLabel: 'Button {index}',
    buttonTypeLabel: 'Type',
    buttonTextLabel: 'Button Text',
    buttonTextPlaceholder: 'Display text',
    noUnderscore: 'Cannot contain underline (_)',
    buttonUrlLabel: 'URL *',
    buttonUrlPlaceholder: 'https://example.com',
    buttonUrlHint: 'Valid URL required. Max {max} characters.',
    buttonsCount: '{count}/10 button(s) added',
    quickReplyCount: 'Quick Reply:',
    buttonsLimitsTitle: 'Button Limits',
    buttonsLimitTotal: 'Maximum of 10 buttons total',
    buttonsLimitQuickReply: 'Quick Reply: up to {max} buttons, unique names, no underline (_)',
    buttonsLimitUrl: 'Visit Website: up to {max} button, valid URL required',
    limitReached: '(limit reached)',
    quickReplyTitle: 'Quick Reply',
    ctaTitle: 'Call to Action',
    optionalLabel: 'Optional',
    addQuickReply: '+ Add Quick Reply',
    addCta: '+ Add Call to Action',
    noQuickReplyButtons: 'No quick reply buttons added',
    noCtaButtons: 'No call to action buttons added',
    quickReplyLabel: 'Quick Reply {index}',
    formatBold: 'Bold',
    formatItalic: 'Italic',
    formatStrikethrough: 'Strikethrough',
    formatMonospace: 'Monospace',
  },

  detail: {
    backToList: 'Back to List',
    status: 'Status',
    category: 'Category',
    language: 'Language',
    type: 'Type',
    typeSimple: 'Simple',
    typeRich: 'Rich',
    header: 'Header',
    body: 'Message Body',
    footer: 'Footer',
    buttons: 'Buttons',
    preview: 'Message Preview',
    notFound: 'Template not found',
    loadError: 'Error loading template',
  },

  listing: {
    title: 'WhatsApp Templates',
    subtitle: 'Manage your WhatsApp message templates',
    createNew: 'Create New Template',
    filterName: 'Name',
    filterNamePlaceholder: 'Search by name or ID...',
    filterStatus: 'Status',
    filterChannel: 'Channel',
    filterCategory: 'Category',
    allCategories: 'All categories',
    emptyTitle: 'No templates found',
    emptyFiltered: 'Try adjusting your search filters',
    emptyNoTemplates: 'Create your first template to get started',
    createFirst: 'Create First Template',
    colNameId: 'Name / ID',
    colStatus: 'Status',
    colLanguage: 'Language',
    colModified: 'Modified',
    colCategory: 'Category',
    colActions: 'Actions',
    copyId: 'Copy ID',
    copied: 'Copied!',
    edit: 'Edit',
    delete: 'Delete',
    cantEditPending: 'Cannot edit templates under review',
    cantEditRejected: 'Cannot edit rejected templates',
    cantDeletePending: 'Cannot delete templates under review',
    cantDeleteRejected: 'Cannot delete rejected templates',
    showing: 'Showing {start}-{end} of {total}',
    previous: 'Previous',
    next: 'Next',
    deleteTitle: 'Delete Template',
    deleteMessage: 'Are you sure you want to delete the template \'{name}\'? This action cannot be undone.',
    deleteMessageWarning: 'Are you sure you want to delete the template \'{name}\'? This action cannot be undone and the template will no longer be available for sending messages.',
    deleteConfirm: 'Delete',
    deleteError: 'Failed to delete template. Please try again.',
    deleting: 'Deleting...',
  },

  editWarning: {
    title: 'Edit Template',
    description: 'Editing this template will require re-approval from Meta. Please be aware of the following:',
    item1: 'The template will be set back to "Under Review" status and may take up to 24 hours to be approved again.',
    item2: 'The template will be unavailable for sending messages until it is approved again.',
    confirm: 'Edit anyway',
  },

  categoryMismatch: {
    title: 'Category does not match',
    description: 'To ensure your message template is approved, choose a category that matches this template\'s content.',
    marketingDesc: 'Send promotions, offers and news to increase engagement.',
    utilityLabel: 'Utility',
    utilityDesc: 'Send messages about an existing account or order.',
    authenticationLabel: 'Authentication',
    authenticationDesc: 'Send codes to verify a transaction or login.',
    selected: 'Selected',
    recommended: 'Recommended',
    warning: 'This message template may be rejected. You can request a review on the Business Support Home Page.',
    continue: 'Continue',
  },

  validation: {
    nameRequired: 'Name is required',
    nameMinLength: 'Name must be at least 3 characters',
    nameMaxLength: 'Name must be at most {max} characters',
    namePattern: 'Use only lowercase letters, numbers and underline (_)',
    nameDuplicate: 'A template with this name already exists for the selected language',
    phoneRequired: 'Phone number is required',
    templateTypeRequired: 'Template type is required',
    bodyRequired: 'Message body is required',
    bodyNoStartVariable: 'Body cannot start with a variable',
    bodyNoEndVariable: 'Body cannot end with a variable',
    bodyNoConsecutiveVariables: 'Body cannot have consecutive variables without text between them',
    bodyNoConsecutiveVariablesShort: 'Cannot have consecutive variables',
    bodyNoDoubleLineBreaks: 'Body cannot have two or more consecutive line breaks',
    bodyMaxLength: 'Body must be at most {max} characters ({type} variables)',
    bodyMinLengthSingle: 'Body must be at least {min} characters when it has 1 variable',
    bodyMinLengthMulti: 'Body must be at least {min} characters when it has {count} variables (20 per variable)',
    headerTextRequired: 'Header text is required',
    headerMaxLength: 'Header must be at most {max} characters',
    footerMaxLength: 'Footer must be at most {max} characters',
    footerNoVariables: 'Footer cannot contain variables',
    buttonTextRequired: 'All buttons must have text',
    buttonTextMaxLength: 'Button text must be at most {max} characters',
    buttonNoUnderscore: 'Quick reply button cannot contain underline (_)',
    urlRequiredForSite: 'URL is required for website button',
    urlRequired: 'URL is required',
    urlInvalid: 'Invalid URL',
    urlMaxLength: 'URL must be at most {max} characters',
    phoneRequiredForCall: 'Phone number is required for call button',
    codeRequired: 'Code is required',
    codeRequiredForCopy: 'Code is required for copy code button',
    codeMaxLength: 'Code must be at most {max} characters',
    variableRequired: 'Example value is required',
    variableNoLineBreak: 'Variable value cannot contain line breaks',
    variableLabel: 'Variable {index}',
    buttonsMaxTotal: 'Maximum of 10 buttons total',
    buttonsUniqueNames: 'Button names must be unique',
    buttonsMaxQuickReply: 'Maximum of {max} quick reply buttons',
    buttonsMaxUrl: 'Maximum of {max} URL button',
    buttonsMaxPhone: 'Maximum of {max} phone button',
    buttonsMaxCopyCode: 'Maximum of {max} copy code button',
    mediaFileRequired: 'Select a file for the header (video or document)',
    mediaAccentWarning: 'Files with accented names may not be sent (Meta limitation)',
  },
} as const
